import LOCALS from 'commons/locals';
import { Control, Controller } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import { Input } from 'antd';

const ProductColorRemark = ({
  control,
}: {
  control: Control<CreateProductFormSchemaType>;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.color_remark)}:</FormLabel>
      <Controller
        name="colorRemark"
        control={control}
        render={({ field }) => (
          <Input.TextArea
            {...field}
            placeholder={i18n.t(LOCALS.please_enter) || ''}
          />
        )}
      />
    </div>
  );
};

export default ProductColorRemark;
